import initI18n from '@rover/shared/js/utils/initI18n';
import inject from '@rover/utilities/injector';

const locale = inject('Rover.context.language', undefined);
const messages = inject('__LINGUI_MESSAGES__', undefined);
initI18n(locale, messages);
